module.exports = __webpack_public_path__ + "img/electric_pending_zone_selected.52e42e2c.svg";